import React, { useRef } from 'react';
import { Link, useStaticQuery, graphql } from 'gatsby';
import FixedFooter from '../components/FixedFooter';
import Footer from '../components/Footer';
import Navigation from '../components/Navigation';
import Share from '../components/Share';
import { Helmet } from 'react-helmet';
import PropTypes from 'prop-types';
import './layout.scss';

const Layout = ({ dynamicTitle, children, showFooter }) => {
  const headerRef = useRef();
  const {
    site: {
      siteMetadata: { title }
    }
  } = useStaticQuery(graphql`
    query {
      site {
        siteMetadata {
          title
        }
      }
    }
  `);
  return (
    <>
      <Helmet>
        <title>{title}</title>
      </Helmet>
      {/* <Loader /> */}
      {/* ================= main start ================*/}
      <div id="main">
        {/* =============== header ===============*/}
        <header ref={headerRef}>
          {/*  header-inner  */}
          <div className="header-inner">
            {/*  header logo */}
            <div className="logo-holder">
              <Link to="/">
                <img src="/images/logo.svg" alt="2M2 LOGO" />
              </Link>
            </div>
            {/*  header logo end */}
            <Navigation />
          </div>
          {/*  header-inner  end */}
          {/*  share button  */}
          <Share headerRef={headerRef} />
          {/*  share  end*/}
        </header>
        {/* =============== wrapper ===============*/}
        <div id="wrapper">
          <div className="content-holder">
            {children}
            {/*  content footer*/}
            {showFooter && <Footer />}
          </div>
        </div>
        {/*  wrapper end */}
        <FixedFooter title={dynamicTitle} />
      </div>
      {/*  Main end */}
    </>
  );
};

Layout.propTypes = {
  dynamicTitle: PropTypes.string.isRequired,
  showFooter: PropTypes.bool.isRequired
};

export default Layout;
